import { render, staticRenderFns } from "./deliveryorder.vue?vue&type=template&id=23eecaf0&scoped=true"
import script from "./deliveryorder.vue?vue&type=script&lang=js"
export * from "./deliveryorder.vue?vue&type=script&lang=js"
import style0 from "./deliveryorder.vue?vue&type=style&index=0&id=23eecaf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eecaf0",
  null
  
)

export default component.exports